import SOAP_API from 'lib/tessitura/SOAP/API';
import REST_API from 'lib/tessitura/REST/API';
import Config from '../../config';
let config;

function getAPIForMode() {
  config = new Config().getConfig();
  switch (config.api_mode.toUpperCase()) {
    case 'REST':
    default:
      return REST_API;
    case 'SOAP':
      return SOAP_API;
  }
}

export default getAPIForMode();



// WEBPACK FOOTER //
// ./src/javascripts/lib/tessitura/API.js